import { render, staticRenderFns } from "./StatisticMenu.vue?vue&type=template&id=3486a9b2&scoped=true"
import script from "./StatisticMenu.vue?vue&type=script&lang=js"
export * from "./StatisticMenu.vue?vue&type=script&lang=js"
import style0 from "./StatisticMenu.vue?vue&type=style&index=0&id=3486a9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486a9b2",
  null
  
)

export default component.exports